<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-spacer></v-spacer>
      <v-col>
        <v-toolbar dark>
          <v-toolbar-title>Account not activated</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="logout">Logout</v-btn>
        </v-toolbar>
        <v-card>
          <v-card-text primary-title>
            Dear user, thank you for registering for
            space<b>studio</b>™.
          </v-card-text>
          <v-card-text primary-title>
            Your account is locked for now.
          </v-card-text>
          <v-card-text primary-title>
            Our team will soon validate your account.
          </v-card-text>
          <v-card-text primary-title>
            As soon as it's validated, you will receive an email.
          </v-card-text>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'pending',

  methods: {
    async logout() {
      delete localStorage.token
      delete localStorage.currentMissionId
      await this.$store.dispatch('logout')
      const referUrl = encodeURI(window.location.origin + window.location.pathname)
      const guardianUrl = process.env.GUARDIAN_URL
      const appName = process.env.APP_NAME
      window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${appName}&goto=logout`
    }
  }
}
</script>

<style scoped></style>
